import React, { FC } from "react";
import { useIntl, defineMessages } from "react-intl";
import { Notification } from "@app/components";

export const messages = defineMessages({
  dobValidationErrorContent: {
    id: "dobValidationErrorContent",
    defaultMessage: "Incorrect date of birth. Please re-enter",
  },
});

const DOBValidationErrorNotification: FC = () => {
  const intl = useIntl();

  return (
    <section className="title__container">
      <Notification type="note">
        <div>{intl.formatMessage(messages.dobValidationErrorContent)}</div>
      </Notification>
    </section>
  );
};

export default DOBValidationErrorNotification;
